import request from '@/utils/request';

export const BUSINESS_UNITS = 'BUSINESS_UNITS';
export const MANAGEABLE_BUSINESS_UNITS = 'MANAGEABLE_BUSINESS_UNITS';
export const BUSINESS_UNIT = 'BUSINESS_UNIT';
export const BUSINESS_UNIT_CUSTOM_DOMAIN = 'BUSINESS_UNIT_CUSTOM_DOMAIN';

// Fetch all business units for the current user
export const fetchBusinessUnits = () => async dispatch => {
  const response = await request({
    path: `/v1/business_units`
  });
  dispatch({
    payload: response,
    type: BUSINESS_UNITS
  });
  return response;
};

// Fetch business units where the user can manage custom domains (BU admin)
export const fetchManageableBusinessUnits = () => async dispatch => {
  const response = await request({
    path: `/v1/business_units/manageable`
  });
  dispatch({
    payload: response,
    type: MANAGEABLE_BUSINESS_UNITS
  });
  return response;
};

// Fetch a specific business unit
export const fetchBusinessUnit = id => async dispatch => {
  const response = await request({
    path: `/v1/business_units/${id}`
  });
  dispatch({
    payload: response,
    type: BUSINESS_UNIT
  });
  return response;
};

// Fetch the custom domain for a specific business unit
export const fetchBusinessUnitCustomDomain = id => async dispatch => {
  const response = await request({
    path: `/v1/business_units/${id}/custom_domain`
  });
  dispatch({
    payload: { ...response, business_unit_id: id },
    type: BUSINESS_UNIT_CUSTOM_DOMAIN
  });
  return response;
};
